import CatalogModelSummary from './models/CatalogModelSummary.js';
import InventoryVehicle from './models/InventoryVehicle.js';

import EnhancedPricing from './models/EnhancedPricing.js';
import Price from './models/Price.js';
import PurchaseTerm from './models/PurchaseTerm.js';
import Incentives from './models/Incentives.js';

import TILE_MODES from './constants/TileModes.js';

import TileDisclaimer from './components/TileDisclaimer/TileDisclaimer.jsx';

const version = process.env.VERSION;

export {
    CatalogModelSummary,
    Incentives,
    InventoryVehicle,
    EnhancedPricing,
    Price,
    PurchaseTerm,
    TileDisclaimer,
    TILE_MODES,
    version,
};

export default {
    CatalogModelSummary,
    Incentives,
    InventoryVehicle,

    EnhancedPricing,
    Price,
    PurchaseTerm,
    TileDisclaimer,
    TILE_MODES,
    version,
};
